export function renderNodeToString(root: HTMLElement): string {
  let text = '';
  root.childNodes.forEach((node: Node) => {
    if (node instanceof HTMLElement && node.hasAttribute('data-token')) {
      const tokenName = node.getAttribute('data-token');
      text += `{{${tokenName || ''}}}`;
    } else if (node.nodeType === Node.TEXT_NODE) {
      text += node.textContent;
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      if (node instanceof HTMLImageElement) {
        text += node.outerHTML;
      } else if (node instanceof HTMLBRElement) {
        text += '\n';
      } else if (node instanceof HTMLElement) {
        if (!(node instanceof HTMLSpanElement)) {
          text += '\n';
        }
        text += renderNodeToString(node);
      }
    } else {
      text += node.nodeValue;
    }
  });

  return text;
}
